"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _validators = _interopRequireDefault(require("@jobmatchme/ui/es/utils/validators"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _useOurTranslation = require("../../utils/useOurTranslation");

var _MailOutline = _interopRequireDefault(require("@material-ui/icons/MailOutline"));

var _OutlinedInput = _interopRequireDefault(require("@material-ui/core/OutlinedInput"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _IntroText = require("../IntroText");

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Selector = _interopRequireDefault(require("./Selector"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FormWithInputs = function FormWithInputs(_ref) {
  var config = _ref.config;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue;

  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loadedInputsStatus = _useState2[0],
      setLoadedInputsStatus = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      changedInputsInvalid = _useState4[0],
      setChangedInputsInvalid = _useState4[1];

  (0, _react.useEffect)(function () {
    Object.entries(config.fields).forEach(function (_ref2) {
      var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          name = _ref3[0],
          field = _ref3[1];

      var savedFieldValue = context && context[name];

      if (!field.defaultValue && !savedFieldValue) {
        setLoadedInputsStatus(function (oldArrayState) {
          return [].concat((0, _toConsumableArray2.default)(oldArrayState), [name]);
        });
      }
    }); // Set Invalid Validation Status for all Form Fileds by Pagestart
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var handleChange = function handleChange(event, identifier) {
    var value = event.target.value;
    setValue(config.valueName, {
      value: (0, _validators.default)(config.inputType)(value) ? value : '',
      identifier: identifier
    });
  };

  var saveDefault = (0, _react.useCallback)(function (formName, savedValue, defaultValue) {
    setValue(formName, {
      value: savedValue ? savedValue : defaultValue,
      identifier: formName
    });
  }, [setValue]);

  var validateInput = function validateInput(event, inputType, identifier) {
    var value = event.target.value;
    var isValid = (0, _validators.default)(inputType)(value) && value !== '' ? true : false;

    if (isValid) {
      // erase field name from array with invalid fields
      setLoadedInputsStatus(loadedInputsStatus.filter(function (item) {
        return item !== identifier;
      }));
      setChangedInputsInvalid(changedInputsInvalid.filter(function (item) {
        return item !== identifier;
      }));
    } else {
      // add fields names who are invalid
      setChangedInputsInvalid(function (oldArrayState) {
        return [].concat((0, _toConsumableArray2.default)(oldArrayState), [identifier]);
      });
    }
  };

  var changeFieldData = function changeFieldData(event, field, identifier) {
    var inputType = field.inputType;
    validateInput(event, inputType, identifier);
    handleChange(event, identifier);
  };

  var checkInvalid = function checkInvalid(fieldName) {
    var status = changedInputsInvalid.includes(fieldName);
    return status;
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.TranslatedIntroText, {
      config: config
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      className: _styleModule.default.textField,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        container: true,
        spacing: 8,
        children: Object.entries(config.fields).map(function (_ref4) {
          var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
              name = _ref5[0],
              field = _ref5[1];

          var isFieldInvalid = checkInvalid(name);

          var defaultValue = function defaultValue() {
            if (context) {
              return context[name] !== undefined ? context[name] : context[config.valueName] ? (context[config.valueName].value || {})[name] : '';
            } else return '';
          };

          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            item: true,
            xs: 12,
            sm: field.width,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl.default, {
              variant: "outlined",
              fullWidth: true,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputLabel.default, {
                htmlFor: "".concat(config.valueName, "-").concat(name, "-input"),
                className: _styleModule.default.label,
                children: t(config.translations[name])
              }), field.inputType !== 'select' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_OutlinedInput.default, {
                fullWidth: true,
                error: isFieldInvalid,
                defaultValue: defaultValue(),
                name: "".concat(config.valueName, "-").concat(name),
                id: "".concat(config.valueName, "-").concat(name, "-input"),
                onBlur: function onBlur(e) {
                  return changeFieldData(e, field, name);
                },
                onChange: function onChange(e) {
                  return changeFieldData(e, field, name);
                },
                type: field.inputType || 'text',
                placeholder: field.placeholder ? t(config.translations.emailPlaceholder) : '',
                startAdornment: field.startAdornment && /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAdornment.default, {
                  position: "start",
                  children: field.inputType === 'mail' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MailOutline.default, {
                    className: _styleModule.default.icon,
                    color: "inherit"
                  })
                }),
                endAdornment: field.endAdornment && /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAdornment.default, {
                  position: "end",
                  children: field.inputType === 'mail' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MailOutline.default, {
                    className: _styleModule.default.icon,
                    color: "inherit"
                  })
                })
              }, "".concat(name, "-inpt")), field.inputType === 'select' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Selector.default, {
                t: t,
                name: "".concat(name),
                changeFieldData: changeFieldData,
                label: t(config.translations[name]),
                translateNs: config.translations,
                fields: field[field.inputType],
                defaultValue: field.defaultValue,
                savedValue: defaultValue(),
                saveDefault: saveDefault
              }), isFieldInvalid && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: _styleModule.default.validationHelper,
                children: t("".concat(config.translations[name], "Helper"))
              })]
            }, "".concat(name, "-frm"))
          }, "".concat(name, "-grid"));
        })
      })
    })]
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(FormWithInputs);

exports.default = _default;